"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Data converter for role approval status.
 *
 * @author Radek Beran
 */


var RoleApprovalStatusConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(RoleApprovalStatusConverter, _DataObjectConverter_);

  function RoleApprovalStatusConverter() {
    _classCallCheck(this, RoleApprovalStatusConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(RoleApprovalStatusConverter).apply(this, arguments));
  }

  return RoleApprovalStatusConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.RoleApprovalStatusConverter = RoleApprovalStatusConverter;